import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const STATUS = { pending: "In review", rejected: "Not approved", approved: "Live" };

export function TitleChips({ titles }) {
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5">
      {(titles || []).map((t) => (
        <Link key={t.id} to={`/title/${t.id}`} className="rounded-full border border-[var(--border-subtle)] px-2.5 py-0.5 text-[11px] font-semibold text-[var(--text-secondary)] hover:border-[var(--accent)] hover:text-[var(--text-primary)]" data-testid={`episode-title-link-${t.id}`}>{t.title}</Link>
      ))}
    </div>
  );
}

export default function EpisodeList({ episodes, showStatus = false, testid = "podcast-episodes", prefix = "episode" }) {
  return (
    <ul className="mt-3 space-y-2" data-testid={testid}>
      {episodes.map((e) => (
        <li key={e.id} className="rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-card)] p-3" data-testid={`${prefix}-${e.id}`}>
          <div className="flex items-start justify-between gap-3">
            <a href={e.url} target="_blank" rel="noopener noreferrer" className="inline-flex min-w-0 items-start gap-1.5 font-semibold text-[var(--text-primary)] hover:text-[var(--accent-hover)]" data-testid={`${prefix}-link-${e.id}`}>
              <ExternalLink size={15} className="mt-0.5 flex-none" /><span className="break-words">{e.title}</span>
            </a>
            {showStatus && <span className={`flex-none rounded px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${e.status === "approved" ? "bg-green-500/20 text-green-400" : e.status === "rejected" ? "bg-red-500/20 text-red-400" : "bg-[var(--text-muted)]/20 text-[var(--text-secondary)]"}`} data-testid={`episode-status-${e.id}`}>{STATUS[e.status]}</span>}
          </div>
          <TitleChips titles={e.titles} />
        </li>
      ))}
    </ul>
  );
}
